module.exports = __webpack_public_path__ + "img/banner-03备份.69a01e0c.png";